module.exports = __webpack_public_path__ + "img/text_new.b29cd7e6.png";